import { _enum, array, boolean, object, schema } from "@anna-money/anna-web-lib/serializer";
import { datetime, genericObject } from "helpers/serialization";

export enum CompanyProduct {
  VirtualOffice = "VIRTUAL_OFFICE",
  Taxes = "TAXES",
  VatRegistration = "VAT_REGISTRATION",
  ConfirmationStatement = "CONFIRMATION_STATEMENT",
  CancellationCover = "CANCELLATION_COVER",
  PayeRegistration = "PAYE_REGISTRATION",
  SharesManagement = "SHARES_MANAGEMENT",
  SameDayRegistration = "SAME_DAY_REGISTRATION",
  DirectorManagement = "DIRECTOR_MANAGEMENT",
  // AU
  RegisterBusinessName = "REGISTER_BUSINESS_NAME",
  AbnRegistration = "ABN_REGISTRATION",
}

export enum VirtualOfficeBillingPeriod {
  Yearly = "YEARLY",
  Monthly = "MONTHLY",
}

export enum VirtualOfficeRegisterEnum {
  RegisteredOffice = "registeredOffice",
  HomeOffice = "homeOffice",
  AlternateOffice = "alternateOffice",
}

export enum RegisterBusinessNamePeriods {
  ThreeYears = "3 years",
  OneYear = "1 year",
  None = "None",
}

export type DefaultCompanyProductDetailsData = Record<string, any>;

export class VirtualOfficeProductDetailsData extends schema(
  {
    billingPeriod: _enum(VirtualOfficeBillingPeriod, "VirtualOfficeBillingPeriod").optional(),
  },
  "VirtualOfficeProductDetailsData",
) {}

export class CompanyProductData extends schema(
  {
    product: _enum(CompanyProduct, "CompanyProduct"),
    details: genericObject(),
  },
  "CompanyProductData",
) {}

export class CompanyProductsData extends schema(
  {
    items: array(object(CompanyProductData)),
  },
  "CompanyProductsData",
) {}

export class CompanyProductChangeData extends schema(
  {
    product: _enum(CompanyProduct, "CompanyProduct"),
    details: genericObject().optional(),
  },
  "CompanyProductChangeData",
) {}

export class FormationExpressStateData extends schema(
  {
    featureAvailable: boolean(),
    currectTimestamp: datetime().optional(),
    availableUntil: datetime().optional(),
  },
  "FormationExpressStateData",
) {}
